import { render, staticRenderFns } from "./recruitStudentTable.vue?vue&type=template&id=ac6792d2&scoped=true&"
import script from "./recruitStudentTable.vue?vue&type=script&lang=js&"
export * from "./recruitStudentTable.vue?vue&type=script&lang=js&"
import style0 from "./recruitStudentTable.vue?vue&type=style&index=0&id=ac6792d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6792d2",
  null
  
)

export default component.exports